class DZModelInfoType{

    /**
     * 主键
     */
    id = "";

    /**
     * 分类名称
     */
    name = "";
}
export default DZModelInfoType;